<div class="card twolistselection" id="{{cid}}" #filterlistTemplate>
  <div class="card-header">
    <div class="form-check">
      <label class="form-check-label" id="{{cid}}_listlabel" for="{{cid}}_checkAll">
        <input class="form-check-input" type="checkbox" attr.aria-describedby="{{cid}}_listhelp" id="{{cid}}_checkAll"
          (change)="selectOrUnselectAll($event)" #inputRef>
        {{listName}}
        <span class="form-check-sign"></span>
      </label>
    </div>
  </div>
  <div class="form-group form-group-sm">
    <label class="sr-only col-form-label" for="{{cid}}_keyword">Search</label>
    <input type="text" class="form-control keyword-search" [(ngModel)]="search" placeholder="Search.."
      id="{{cid}}_keyword" />
  </div>
  <!-- Card block com rolagem -->
  <div class="card-block" [ngStyle]="{'overflow-y': 'auto', 'max-height': maxHeight}">
    <ul class="list-group" id="{{cid}}_ul" tabindex="0" attr.aria-labelledby="{{cid}}_listlabel"
      aria-multiselectable="true" role="listbox">
      <li #option class="list-item" role="option" (click)="onSelect($event, item)" attr.aria-selected={{false}}
        attr.data-code={{item.code}} id="{{cid}}_list_item_{{item.key}}"
        *ngFor="let item of itemsMap | keyvalue | search:'label':search">
        <i *ngIf="item.value.selected == true" class="fa fa-check" attr.aria-hidden="true"></i>
        {{item.value.label}}
      </li>
    </ul>
  </div>
</div>
